(function() {
  var TOBILLERA_IDS = [56114842665300, 56114842698068];
  var REGALO_VARIANT_ID = 56164828938580;
  var ejecutando = false;

  function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates: updates })
    }).then(r => r.json());
  }

  function addGift(cantidad) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        items: [{ id: REGALO_VARIANT_ID, quantity: cantidad, properties: { _regalo: 'true' } }]
      })
    }).then(r => r.json());
  }

  function checkCart() {
    if (ejecutando) return;
    ejecutando = true;

    getCart().then(function(cart) {
      var items = cart.items;

      var totalTobilleras = items.reduce(function(sum, item) {
        if (TOBILLERA_IDS.includes(item.variant_id)) return sum + item.quantity;
        return sum;
      }, 0);

      var regalosCorrectos = 0;
      if (totalTobilleras >= 3) regalosCorrectos = 2;
      else if (totalTobilleras >= 2) regalosCorrectos = 1;

      var regalosActuales = items.reduce(function(sum, item) {
        if (item.variant_id === REGALO_VARIANT_ID) return sum + item.quantity;
        return sum;
      }, 0);

      if (regalosActuales === regalosCorrectos) {
        ejecutando = false;
        return;
      }

      var accion;
      if (regalosCorrectos === 0 || regalosActuales > 0) {
        accion = updateCart({ [REGALO_VARIANT_ID]: regalosCorrectos });
      } else {
        accion = addGift(regalosCorrectos);
      }

      accion.then(function() {
        ejecutando = false;
        // Avisar al tema que el carrito cambió (sin recargar)
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });

    }).catch(function() {
      ejecutando = false;
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button, [data-add-to-cart], .product-form__submit');
    if (btn) setTimeout(checkCart, 1500);
  });

  setInterval(checkCart, 4000);
  checkCart();

})();